export type CsvField = 'email' | 'firstName' | 'shopifyCode';

const ALIASES: Record<CsvField, readonly string[]> = {
  email: ['email', 'e-mail', 'courriel', 'adresse email', 'adresse e-mail', 'mail'],
  firstName: ['prenom', 'first name', 'firstname', 'first_name', 'given name'],
  shopifyCode: [
    'code',
    'code promo',
    'discount code',
    'coupon',
    'coupon code',
    'promo code',
    'code de reduction',
  ],
};

export const REQUIRED_FIELDS: readonly CsvField[] = ['email', 'firstName'] as const;

const stripAccents = (value: string): string => value.normalize('NFD').replace(/[̀-ͯ]/g, '');

export const normalizeHeader = (header: string): string =>
  stripAccents(header.toLowerCase().trim()).replace(/\s+/g, ' ');

export type HeaderMapping = Partial<Record<CsvField, string>>;

export const detectHeaderMapping = (headers: readonly string[]): HeaderMapping => {
  const mapping: HeaderMapping = {};
  const normalized = headers.map((h) => ({ original: h, normalized: normalizeHeader(h) }));

  (Object.keys(ALIASES) as CsvField[]).forEach((field) => {
    const aliases = ALIASES[field].map(normalizeHeader);
    const match = normalized.find((h) => aliases.includes(h.normalized));
    if (match) {
      mapping[field] = match.original;
    }
  });

  return mapping;
};

export const getMissingRequiredFields = (mapping: HeaderMapping): CsvField[] =>
  REQUIRED_FIELDS.filter((field) => !mapping[field]);
